import React from 'react';
import {Result} from 'antd';

const App: React.FC = () => (
  <Result
    status='500'
    title='500'
    subTitle='Sorry, something went wrong.'
    style={{paddingTop: '20%'}}
  />
);

export default App;
